import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, AuthCallback, Protected } from "./context/AuthContext";
import Nav from "./components/Nav";
import { Footer } from "./components/Bits";
import Landing from "./pages/Landing";
import Discover from "./pages/Discover";
import PublicBook from "./pages/PublicBook";
import PublicAuthor from "./pages/PublicAuthor";
import Dashboard from "./pages/Dashboard";
import BookForm from "./pages/BookForm";
import Workspace from "./pages/Workspace";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import SignIn from "./pages/SignIn";

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Nav />
      <main className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/b/:slug" element={<PublicBook />} />
          <Route path="/a/:slug" element={<PublicAuthor />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/books/new" element={<Protected><BookForm /></Protected>} />
          <Route path="/books/:id/edit" element={<Protected><BookForm /></Protected>} />
          <Route path="/books/:id" element={<Protected><Workspace /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <div className="paper-grain" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
